import React from "react";
import { RouteProps } from "react-router";

import ScheduleContainer from "containers/schedule/schedule_container";
import SettingsContainer from "containers/settings/settings_container";
import PublicContainer from "containers/schedule/public_container";
import WebcalRedirect from "components/webcal_redirect";

interface IRoutes {
  [key: string]: RouteProps;
}

// By using an object with named keys we can use this for both
// the dynamically generated list of all routes at the root of our
// application as well as links throughout without needing to hardcode
// paths anywhere.
const ROUTES: IRoutes = {
  PUBLIC_SCHEDULE: {
    path: "/:urlInput",
    render: props => <PublicContainer {...props} interactiveView={false} />,
  },
  SCHEDULING: {
    path: "/s/:permalink/schedule",
    render: props => <ScheduleContainer {...props} interactiveView={true} />,
  },
  SETTINGS: {
    path: "/s/:permalink/settings",
    component: SettingsContainer,
  },
  WEBCAL: {
    path: "/s/:permalink/calendars/:uuid",
    component: WebcalRedirect,
  },
};

export default ROUTES;
